module.exports = __webpack_public_path__ + "img/6.1fee39c3.jpg";